import * as React from "react";
import styled from "styled-components";

import { LogoLink } from "../Navigation";
import { AccountNav } from "../AccountNav/AccountNav";
import { Menu as MenuIcon } from "../../Svg/MenuIcon";
import { BorderedNavLink } from "../NavLink";
import { Logo } from "../../Svg/Logo";
import { TRACKING_CODES } from "../../../consts/trackingCodes";
import { BREAK_POINTS } from "../../../consts/style";

const MobileContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-height: ${BREAK_POINTS.MAX.MD}) {
    max-height: 64px;
    box-sizing: border-box;
  }
`;

const Left = styled.div`
  display: flex;
`;

export const Hamburger = styled(BorderedNavLink)`
  color: ${p => p.theme.colors.grey500};
  svg {
    fill: ${p => p.theme.colors.grey500};
  }
`;

export const MobileMenuBar = ({ logoLinkHref, toggleMenu }) => (
  <MobileContainer>
    <Left>
      <LogoLink
        trackingType="navMobileLogoLink"
        data-id="mobile-logolink"
        href={logoLinkHref}
      >
        <Logo id="mobile-nav" />
      </LogoLink>
      <Hamburger
        href={logoLinkHref}
        data-id={TRACKING_CODES.TOGGLE_NAVIGATION}
        trackingType="navMobile"
        data-comment="MobileNavButton"
        onClick={(e?: React.MouseEvent<HTMLAnchorElement>) => {
          toggleMenu();
          e && e.preventDefault();
        }}
      >
        <MenuIcon />
        <span>Menu</span>
      </Hamburger>
    </Left>
    <AccountNav />
  </MobileContainer>
);
